<!-- 公司基础信息 -->
<template>
    <div class="container">
        <!-- 基础信息 -->
        <div class="content section-basic">
            <div class="section-header">
                <Icon type="ios-business-outline" size="20" />
                <span>基础信息</span>
            </div>
            <Form :model="formData" label-position="right" :label-width="140">
                <Row :gutter="24">
                    <Col span="8">
                        <FormItem label="公司名称：">
                            <Input type="text" v-model="formData.company_name" placeholder="请输入公司名称"></Input>
                        </FormItem>
                    </Col>
                    <Col span="8">
                        <FormItem label="公司负责人：">
                            <Input type="text" v-model="formData.contact" placeholder="请输入公司负责人"></Input>
                        </FormItem>
                    </Col>
                    <Col span="8">
                        <FormItem label="负责人联系方式：">
                            <Input type="text" v-model="formData.mobile" placeholder="请输入负责人联系方式"></Input>
                        </FormItem>
                    </Col>
                </Row>
                <Row :gutter="24">
                    <Col span="24">
                        <FormItem label="公司联系地址：">
                            <Input type="text" v-model="formData.address" placeholder="请输入公司联系地址"></Input>
                        </FormItem>
                    </Col>
                </Row>
                <Row :gutter="24">
                    <Col span="24">
                        <FormItem label="公司简介：">
                            <Input type="textarea" v-model="formData.desc" :autosize="{minRows: 3,maxRows: 6}" placeholder="请输入公司简介"></Input>
                        </FormItem>
                    </Col>
                </Row>
            </Form>
        </div>

        <!-- 证照图片 -->
        <div class="content section-license">
            <div class="section-header">
                <Icon type="ios-card-outline" size="20" />
                <span>证照图片</span>
            </div>
            <Form :model="formData" label-position="right" :label-width="140">
                <Row :gutter="24">
                    <Col span="24">
                        <FormItem label="公司logo：">
                            <div class="upload-area">
                                <div class="form_upload" @click="openModal(1)">
                                    <Icon type="ios-add" size="32" color="#AEAEB3"/>
                                </div>
                                <div v-if="formData.show_logo" class="form_upload position_relative">
                                    <Icon class="form_icon" size="20" type="ios-close-circle" color="#f00" @click.stop="delImg(1)"/>
                                    <img class="form_img" :src="formData.show_logo" @click="previewImg(formData.show_logo)">
                                </div>
                            </div>
                        </FormItem>
                    </Col>
                </Row>
                <Row :gutter="24">
                    <Col span="24">
                        <FormItem label="营业执照：">
                            <div class="upload-area">
                                <div class="form_upload" @click="openModal(2)">
                                    <Icon type="ios-add" size="32" color="#AEAEB3"/>
                                </div>
                                <div v-if="formData.show_license" class="form_upload position_relative">
                                    <Icon class="form_icon" size="20" type="ios-close-circle" color="#f00" @click.stop="delImg(2)"/>
                                    <img class="form_img" :src="formData.show_license" @click="previewImg(formData.show_license)">
                                </div>
                            </div>
                        </FormItem>
                    </Col>
                </Row>
            </Form>
        </div>

        <!-- 相册管理 -->
        <div class="content section-gallery">
            <div class="section-header">
                <Icon type="ios-photos-outline" size="20" />
                <span>相册管理</span>
            </div>
            <Form :model="formData" label-position="right" :label-width="140">
                <Row :gutter="24">
                    <Col span="24">
                        <FormItem label="其他资质：">
                            <div class="image-list">
                                <div class="form_upload" @click="openModal(0, 3)">
                                    <Icon type="ios-add" size="32" color="#AEAEB3"/>
                                </div>
                                <div v-for="(item, index) in show_other" :key="'other-'+index" class="form_upload position_relative">
                                    <Icon class="form_icon" size="20" type="ios-close-circle" color="#f00" @click.stop="delImg(3, index)"/>
                                    <img class="form_img" :src="item" @click="previewImg(item)">
                                </div>
                            </div>
                        </FormItem>
                    </Col>
                </Row>
                <Row :gutter="24">
                    <Col span="24">
                        <FormItem label="公司图片：">
                            <div class="image-list">
                                <div class="form_upload" @click="openModal(0, 4)">
                                    <Icon type="ios-add" size="32" color="#AEAEB3"/>
                                </div>
                                <div v-for="(item, index) in show_pic" :key="'pic-'+index" class="form_upload position_relative">
                                    <Icon class="form_icon" size="20" type="ios-close-circle" color="#f00" @click.stop="delImg(4, index)"/>
                                    <img class="form_img" :src="item" @click="previewImg(item)">
                                </div>
                            </div>
                        </FormItem>
                    </Col>
                </Row>
            </Form>
        </div>

        <!-- 提交按钮 -->
        <div class="footer">
            <Button class="theme-bc theme-default-color btn-submit" @click="submitForm">
                <Icon type="ios-checkmark-circle-outline" size="18" /> 确定保存
            </Button>
        </div>

        <pictureLibrary
            v-if="switch_modal"
            :switch_modal.sync="switch_modal"
            :select="imgtype"
            @change="costPlannedAmountChange"
        ></pictureLibrary>
    </div>
</template>

<script>
import { system_company_index, system_company_save } from '@/api/index';
import pictureLibrary from "@/components/pictureLibrary/pictureLibrary.vue";
export default {
    components: { pictureLibrary },
    data() {
        return {
            srctype: "",
            imgtype: 1,
            switch_modal: false,
            formData: {
                company_name: "",
                logo: "",
                license: "",
                other: "",
                contact: "",
                mobile: "",
                address: "",
                pic: "",
                desc: "",
                show_logo: "",
                show_license: "",
            },
            show_other: [],
            show_pic: [],
            otherList: [],
            picList: [],
        };
    },
    mounted() {
        this.getList();
    },
    methods: {
        async costPlannedAmountChange(param1, param2) {
            if (this.imgtype == 1) {
                for (var i = 0; i < param1.length; i++) {
                    this.formData.show_logo = param1[i];
                }
                for (var i = 0; i < param2.length; i++) {
                    this.formData.logo = param2[i];
                }
                this.$Message.destroy();
            }else if(this.imgtype == 2) {
                for (var i = 0; i < param1.length; i++) {
                    this.formData.show_license = param1[i];
                }
                for (var i = 0; i < param2.length; i++) {
                    this.formData.license = param2[i];
                }
                this.$Message.destroy();
            }else if(this.imgtype == 0 && this.srctype == 3) {
                for (var i = 0; i < param1.length; i++) {
                    this.show_other.push(param1[i]);
                }
                for (var i = 0; i < param2.length; i++) {
                    this.otherList.push(param2[i]);
                }
                this.$Message.destroy();
            }else if(this.imgtype == 0 && this.srctype == 4) {
                for (var i = 0; i < param1.length; i++) {
                    this.show_pic.push(param1[i]);
                }
                for (var i = 0; i < param2.length; i++) {
                    this.picList.push(param2[i]);
                }
                this.$Message.destroy();
            }
        },
        openModal(e, index) {
            this.imgtype = e;
            this.srctype = index;
            this.switch_modal = true;
        },
        getList(){
            system_company_index().then((res) => {
                if(res.data && res.data.length != 0){
                    this.formData.company_name = res.data.company_name;
                    this.formData.logo = res.data.logo;
                    this.formData.license = res.data.license;
                    this.formData.other = res.data.other;
                    this.formData.contact = res.data.contact;
                    this.formData.mobile = res.data.mobile;
                    this.formData.address = res.data.address;
                    this.formData.pic = res.data.pic;
                    this.formData.desc = res.data.desc;
                    if(res.data.logo){
                        this.formData.show_logo = res.data.show_logo;
                    }
                    if(res.data.license){
                        this.formData.show_license = res.data.show_license;
                    }
                    localStorage.setItem('companyData', JSON.stringify(res.data));
                    if(res.data.other){
                        this.otherList = res.data.other.split(',');
                    }
                    if(res.data.pic){
                        this.picList = res.data.pic.split(',');
                    }
                    this.show_other = res.data.show_other;
                    this.show_pic = res.data.show_pic;
                }
            })
            .catch((err) => {
                this.$Message.error(err.msg);
            });
        },
        submitForm(){
            this.formData.other = this.otherList.join(',');
            this.formData.pic = this.picList.join(',');
            system_company_save(this.formData).then( res => {
                this.getList();
                this.$Message.success(res.msg);
            }).catch(res=>{
                this.$Message.error(res.msg);
            })
        },
        delImg(e, index){
            if(e == 1){
                this.formData.logo = ''
                this.formData.show_logo = ''
            }else if(e == 2){
                this.formData.license = ''
                this.formData.show_license = ''
            }else if(e == 3){
                this.otherList.splice(index, 1);
                this.show_other.splice(index, 1);
            }else if(e == 4){
                this.picList.splice(index, 1);
                this.show_pic.splice(index, 1);
            }
        },
        previewImg(item){
            if(item){
                window.open(item);
            }
        },
    },
};
</script>

<style scoped>
.container {
    display: flex;
    flex-direction: column;
    gap: 16px;
}
.content {
    padding: 20px 24px;
    background: #ffffff;
    box-shadow: 0px 0px 4px 0px rgba(82, 102, 136, 0.1);
    border-radius: 5px;
}
/* 区块标题 */
.section-header {
    display: flex;
    align-items: center;
    margin-bottom: 20px;
    padding-bottom: 12px;
    border-bottom: 2px solid #f0f0f0;
    font-weight: 600;
    font-size: 16px;
    color: #333;
}
.section-header i {
    margin-right: 8px;
    color: #666;
}
/* 基础信息区块 */
.section-basic {
    border-left: 4px solid #2563eb;
}
.section-basic .section-header i {
    color: #2563eb;
}
/* 证照图片区块 */
.section-license {
    border-left: 4px solid #8b5cf6;
}
.section-license .section-header i {
    color: #8b5cf6;
}
/* 相册管理区块 */
.section-gallery {
    border-left: 4px solid #ec4899;
}
.section-gallery .section-header i {
    color: #ec4899;
}
/* 页脚 */
.footer {
    padding: 20px 0;
    text-align: center;
    background: #ffffff;
    box-shadow: 0px 0px 4px 0px rgba(82, 102, 136, 0.1);
    border-radius: 5px;
}
.btn-submit {
    padding: 5px 40px;
    font-size: 15px;
}
.btn-submit i {
    margin-right: 6px;
}
/* 上传样式 */
.form_upload {
    width: 80px;
    height: 80px;
    background: #FFFFFF;
    border-radius: 5px;
    border: 1px solid #dcdee2;
    cursor: pointer;
    display: flex;
    align-items: center;
    justify-content: center;
}
.form_upload:hover {
    border-color: #2563eb;
}
.form_img {
    width: 78px;
    height: 78px;
    border-radius: 5px;
}
.upload-area {
    display: flex;
    align-items: center;
    gap: 12px;
}
.image-list {
    display: flex;
    flex-wrap: wrap;
    gap: 12px;
}
.position_relative {
    position: relative;
}
.form_icon {
    position: absolute;
    top: -10px;
    right: -10px;
    background: #fff;
    border-radius: 50%;
}
</style>
